<div class="title-wrapper flex">
  <h3 class="font-heading-4 ms-xsmall-r font-title-medium">{{ 'seatMap.seatTypesTitle' | finLocalization }}</h3>
  <fcom-icon-button
    *ngIf="(seatMap$ | async)?.isWetlease === false"
    class="flex flex--self-center ms-xsmall-r"
    id="seat-type-read-more"
    [icon]="{ name: SvgLibraryIcon.INFO }"
    [theme]="IconButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
    [size]="IconButtonSize.SMALL"
    [aria]="{ label: 'readMore' | finLocalization }"
    aria-labelledby="seat-type-read-more"
    (clickBtn)="openModal()"
  />
  @if (showPersonalizedDiscountTag$ | async; as discountTagText) {
    <fcom-tag class="ms-xsmall-l" data-testid="seat-chips-discount-tag" [theme]="TagTheme.POPULAR">
      {{ discountTagText }}
    </fcom-tag>
  }
</div>
<fcom-carousel
  class="block overflow-auto"
  [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
  [nextButtonAriaLabel]="'carousel.next' | finLocalization"
>
  <div class="flex flex--nowrap">
    @for (seatType of availableSeatTypes$ | async; track seatType.seatType; let i = $index) {
      <fcom-chip
        class="ms-small-y flex--inline"
        [class.ms-xsmall-l]="i !== 0"
        [attr.data-testid]="'seat-type-' + seatType.className"
        [theme]="seatType.bundle ? ChipTheme.POPULAR : ChipTheme.LIGHT"
        [iconCategory]="IconLibrary.CUSTOM"
        (tagClicked)="handleClick(seatType)"
      >
        <div class="flex">
          <div class="seat-type-svg flex-1 ms-xsmall-y">
            <div class="aircraft-seat-map" [ngClass]="seatMapThemeClass()">
              <svg class="icon-large block" viewBox="0 0 48 44" [innerHTML]="seatType.icon | finSafe: 'html'">
                {{ seatType.icon }}
              </svg>
            </div>
          </div>
          <div class="flex-1 ms-xxsmall-t ms-xxsmall-l flex--grow">
            @if (seatType.bundle) {
              <div class="font-body-2 align-left flex font-body-small">
                {{ seatType.label | finLocalization }} +
                <fcom-icon class="icon-small flex--self-center" [name]="getIconForServiceCategory(seatType.bundle)" />
              </div>
            } @else {
              <div class="font-body-2 align-left font-body-small">{{ seatType.label | finLocalization }}</div>
            }
            <div class="font-body-2 align-left font-body-small">
              <ng-container *ngIf="seatType.originalPrice">
                <span class="strike-through ms-xxsmall-r">{{ seatType.originalPrice | finPrice }},</span>
                <span class="heather-800-text text-icon-primary">{{ seatType.price | finPrice }}</span>
              </ng-container>
              <ng-container *ngIf="!seatType.originalPrice">
                <span>{{ seatType.price | finPrice }}</span>
              </ng-container>
            </div>
          </div>
        </div>
      </fcom-chip>
    }
  </div>
</fcom-carousel>

<fcom-modal
  class="seat-type-modal"
  title="{{ 'seatMap.seatTypesTitle' | finLocalization }}"
  [open]="seatTypeModalOpen"
  (close)="closeModal()"
  [buttons]="ModalButtons.CLOSE"
>
  <ng-container *ngIf="seatTypeModalOpen">
    <div class="relative" *ngIf="availableSeatTypesInModal">
      <ng-container *ngFor="let seatType of availableSeatTypesInModal">
        <div class="pr-large-x pr-xxsmall-y">
          <ng-container *ngIf="seatType.article$ | async as article">
            <div class="seat-type-wrapper flex flex--row ps-small-x ps-medium-y border-bottom">
              <div
                data-testid="seat-map-image"
                class="flex-1 flex--basis0 fill image-wrapper ps-medium-r ps-small-b"
                *ngIf="article.picture as imageData"
              >
                <fin-content-image class="rounded-large" [imageData$]="imageData | finToObservable" />
              </div>
              <div class="flex-1 flex--basis0 fill">
                <cms-rich-text
                  [attr.data-testid]="'seat-type-title-' + article.contentId"
                  [extraClasses]="'font-body-1 font-body-medium'"
                  [headerLevel]="2"
                  [hideMediaContentImage]="
                    !!article.picture && article.picture.contentId === article.media?.[0]?.contentId
                  "
                  [content$]="seatType.article$"
                />
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</fcom-modal>
